if ($(".media--dropdown").length > 0) {
  $(".media--dropdown")
    .selectric({
      maxHeight: 300,
      disableOnMobile: false,
    })
    .on("change", function (e, element, selectric) {
      e.preventDefault();
      filterMediaCategory($(this).val());
    });
}

var filterMediaCategory = function (val) {
  let category = val;
  window.location.href = val;
};
